import { AnimeInstance } from "animejs";
import Scene from "../classes/scene";
import SceneManager from "../classes/scene-manager";
import { ScrollDirection } from "../classes/scroll-manager";
import { getEl, isGreaterThanOrEqualTo } from "../helpers";
import { ScrollAnimation } from "../components/scrolllocked-animations";
import ResponsiveWatcher, { ResponsiveSize } from "../classes/responsive-watcher";
import Globals from "../classes/globals";

export default class ProtectingNature extends Scene {
  sidewaysScroller: ScrollAnimation;
  // sidewaysScrollerSpotlights: ScrollAnimation;
  easeAnimation: ScrollAnimation;
  // easeAnimationSpotlights: ScrollAnimation;

  constructor(manager: SceneManager, targetContainer: string) {
    super(manager, targetContainer);

    const scroller = this.elContainer.querySelector(".pn-sidescroller");
    const scrollerSpotlight = this.elContainer.querySelector(".pn-spotlight-scroller");

    if (!scroller) return;

    const imagesToTrigger: { el: Element; progress: number; done: boolean }[] = [
      // {
      // 	el: this.elContainer.querySelector('.pn-1 .image-frame'),
      // 	progress: 0,
      // 	done: false,
      // },
      // {
      // 	el: this.elContainer.querySelector('.pn-2 .image-frame'),
      // 	progress: 1,
      // 	done: false,
      // },
      {
        el: this.elContainer.querySelector(".pn-3 .image-frame"),
        progress: 30,
        done: false,
      },
    ];

    this.sidewaysScroller = this.addScrollAnimation(
      {
        targets: scroller,
        duration: 1000,
        delay: 0,
        translateX: ["0%", "-60%"], //End translate is = 100 - (100 / scroller width ratio). If scroller width is 250% then total item width is 100 -(100 / 2.5) = 60;
        easing: "easeInOutSine",
        update: (anim: AnimeInstance) => {
          for (let i = imagesToTrigger.length - 1; i >= 0; i--) {
            if (!imagesToTrigger[i].done) {
              if (anim.progress >= imagesToTrigger[i].progress) {
                imagesToTrigger[i].el.dispatchEvent(new CustomEvent("play"));
                imagesToTrigger[i].done = true;
              }
            }
          }
        },
      },
      this.elContainer.querySelector(".pn-sticky-container"),
      100,
      0,
      1,
      -1.5,
      -0.5,
      0.5
    );

    this.easeAnimation = this.addScrollAnimation(
      {
        targets: this.elContainer.querySelector(".pn-sticky"),
        duration: 800,
        top: [
          { value: "100vh", duration: 0 },
          { value: "0vh", duration: 400 },
          { value: "0vh", duration: 400 },
          { value: "-50vh", duration: 200, easing: "easeInSine" },
        ],
        easing: "easeOutSine",
      },
      this.elContainer.querySelector(".pn-sticky-container"),
      60,
      0,
      1,
      0,
      0.5,
      0.7
    );

    // this.sidewaysScrollerSpotlights = this.addScrollAnimation({
    // 	targets: scrollerSpotlight,
    // 	duration: 1000,
    // 	delay: 0,
    // 	translateX: ['0%', '-100%'],
    // 	easing: 'easeInOutSine',
    // }, this.elContainer.querySelector('.pn-spotlight-container'), 100, 0, 1, -1.5, -0.8, 0.5);
    // this.easeAnimationSpotlights = this.addScrollAnimation({
    // 	targets: this.elContainer.querySelector('.pn-spotlight-sticky'),
    // 	duration: 1000,
    // 	top: [
    // 		{ value: '100vh', duration: 0 },
    // 		{ value: '0vh', duration: 300 },
    // 		{ value: '0vh', duration: 300 },
    // 		{ value: '-50vh', duration: 200, easing: 'easeInSine' },
    // 	],
    // 	easing: 'easeOutSine',
    // }, this.elContainer.querySelector('.pn-spotlight-container'), 100, 0, 1, 0, 0.6, 0.7);

    const spotlight1 = this.elContainer.querySelector(".pn-spotlight-1");
    const spotlight2 = this.elContainer.querySelector(".pn-spotlight-2");
    const spotlight3 = this.elContainer.querySelector(".pn-spotlight-3");

    //SPOTLIGHT 1 ANIMATION
    const spot1img = spotlight1.querySelector(".spot-image-background img");

    let dx = 0;
    let dy = 0;

    manager.app.spotlighter.addSpotlightAnimation(
      {
        targets: spotlight1.querySelector(".spot-image-background"),
        scale: [1, 1.1],
        duration: 2000,
        easing: "easeOutQuart",
      },
      spotlight1,
      200,
      (anim, delta) => {
        const xRatio = (anim.mouseX / anim.elWidth - 0.5) * -0.8;
        const yRatio = (anim.mouseY / anim.elHeight - 0.5) * -1;
        dx += (xRatio - dx) * delta * anim.smoothSpeed;
        dy += (yRatio - dy) * delta * anim.smoothSpeed;
        // @ts-ignore
        spot1img.style.transform = "translate(" + dx + "vw, " + dy + "vw)";
      },
      () => {
        spotlight1.querySelector(".spot-heading").dispatchEvent(new CustomEvent("play"));
      },
      true
    );

    //SPOTLIGHT 2 ANIMATION
    const spotvals = [
      {
        el: getEl(".pn-spotlight-2 .spot-image-side img"),
        dx: 0,
        dy: 0,
        amount: -1,
      },
    ];

    manager.app.spotlighter.addSpotlightAnimation(
      {
        targets: spotlight2.querySelector(".zoomer"),
        scale: [1, 1.05],
        duration: 2000,
        easing: "easeOutQuart",
      },
      spotlight2,
      200,
      (anim, delta) => {
        const xRatio = anim.mouseX / anim.elWidth - 0.5;
        const yRatio = anim.mouseY / anim.elHeight - 0.5;

        for (let i = 0; i < spotvals.length; i++) {
          const targetDx = xRatio * spotvals[i].amount;
          const targetDy = yRatio * spotvals[i].amount;
          spotvals[i].dx += (targetDx - spotvals[i].dx) * delta * anim.smoothSpeed;
          spotvals[i].dy += (targetDy - spotvals[i].dy) * delta * anim.smoothSpeed;

          // @ts-ignore
          spotvals[i].el.style.transform = "translate(" + spotvals[i].dx + "vw, " + spotvals[i].dy + "vw)";
        }
      },
      () => {
        spotlight2.querySelector(".spot-heading").dispatchEvent(new CustomEvent("play"));
      },
      true
    );

    //SPOTLIGHT 3 ANIMATION
    const spot3img = spotlight3.querySelector(".spot-image-background img");

    let dx3 = 0;
    let dy3 = 0;

    manager.app.spotlighter.addSpotlightAnimation(
      {
        targets: spotlight3.querySelector(".spot-image-background"),
        scale: [1, 1.1],
        duration: 2000,
        easing: "easeOutQuart",
      },
      spotlight3,
      200,
      (anim, delta) => {
        const xRatio = (anim.mouseX / anim.elWidth - 0.5) * -1;
        const yRatio = (anim.mouseY / anim.elHeight - 0.5) * -1;
        dx3 += (xRatio - dx3) * delta * anim.smoothSpeed;
        dy3 += (yRatio - dy3) * delta * anim.smoothSpeed;
        // @ts-ignore
        spot3img.style.transform = "translate(" + dx3 + "vw, " + dy3 + "vw)";
      },
      () => {
        spotlight3.querySelector(".spot-heading").dispatchEvent(new CustomEvent("play"));
      },
      true
    );

    //Spotlight interaction:
    spotlight1.addEventListener("click", (e) => {
      e.preventDefault();
      manager.app.modaller.openModal("waterconservation");
    });
    spotlight2.addEventListener("click", (e) => {
      e.preventDefault();
      manager.app.modaller.openModal("water");
    });
    spotlight3.addEventListener("click", (e) => {
      e.preventDefault();
      manager.app.modaller.openModal("aquifer");
    });
  }

  onResponsiveChange(newSize: ResponsiveSize, oldSize: ResponsiveSize, responser: ResponsiveWatcher) {
    if (isGreaterThanOrEqualTo(newSize, ResponsiveSize.lg)) {
      this.manager.app.scrolllocker.enableAnimation(this.sidewaysScroller);
      this.manager.app.scrolllocker.enableAnimation(this.easeAnimation);
    } else {
      this.manager.app.scrolllocker.disableAnimation(this.sidewaysScroller);
      this.manager.app.scrolllocker.disableAnimation(this.easeAnimation);
    }

    // if (isGreaterThanOrEqualTo(newSize, ResponsiveSize.xl))
    // {
    // 	this.manager.app.scrolllocker.enableAnimation(this.sidewaysScrollerSpotlights);
    // 	this.manager.app.scrolllocker.enableAnimation(this.easeAnimationSpotlights);
    // }
    // else {
    // 	this.manager.app.scrolllocker.disableAnimation(this.sidewaysScrollerSpotlights);
    // 	this.manager.app.scrolllocker.disableAnimation(this.easeAnimationSpotlights);

    // }
  }

  onEnteredView(dir: ScrollDirection) {
    super.onEnteredView(dir);

    if (this.manager.app.responser.isSmallerOrEqualTo(ResponsiveSize.lg)) {
      const images = this.elContainer.querySelectorAll(".pn-sidescroller .image-frame:not(.autoplay)");
      for (let i = 0; i < images.length; i++) {
        images[i].dispatchEvent(new CustomEvent("play"));
      }
    }
  }
}
